import { Box, Container, Heading, Text } from '@radix-ui/themes';
import { Breadcrumbs } from '@trashlab/sitesapp/src/organizations/denversiteworks/template/components/shared/breadcrumbs';
import { useTenantContext } from '@trashlab/sitesapp/src/organizations/denversiteworks/contexts/use-tenant-context';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';

const TermsPage = () => {
  const { website } = useTenantContext();

  return (
    <Container size="4" p="8">
      <Breadcrumbs title="Terms & Conditions" light />

      <Box className="space-y-8 py-8">
        <Box className="space-y-4">
          <Heading as="h2" size="5" className="text-blue-950">
            1. Introduction
          </Heading>
          <Text as="p" size="3" className="text-slate-600">
            Welcome to {website?.organization.name}! These Terms and Conditions
            outline the rules and regulations for the use of{' '}
            {website?.organization.name}'s Website, located at{' '}
            {website?.domain.domain}. By accessing this website, we assume you
            accept these terms and conditions. Do not continue to use
            {website?.domain.domain} if you do not agree to all of the terms and
            conditions stated on this page.
          </Text>
        </Box>

        <Box className="space-y-4">
          <Heading as="h2" size="5" className="text-blue-950">
            2. Definitions
          </Heading>
          <Text as="p" size="3" className="text-slate-600">
            In these terms and conditions:
          </Text>
          <ul className="list-disc pl-6 space-y-2">
            <li className="text-slate-600">
              <Text size="3">
                "Client," "You," and "Your" refer to you, the person using this
                website and agreeing to the Company's terms and conditions.
              </Text>
            </li>
            <li className="text-slate-600">
              <Text size="3">
                "The Company," "Ourselves," "We," "Our," and "Us" refer to{' '}
                {website?.organization.name}.
              </Text>
            </li>
            <li className="text-slate-600">
              <Text size="3">
                "Parties," "Party," or "Us" refer to both the Client and
                ourselves.
              </Text>
            </li>
          </ul>
        </Box>

        <Box className="space-y-4">
          <Heading as="h2" size="5" className="text-blue-950">
            3. Services
          </Heading>
          <Text as="p" size="3" className="text-slate-600">
            We offer waste delivery services, which include the collection,
            transportation, and disposal of waste materials as per the
            regulatory requirements. The specifics of the services will be
            outlined in the inBoxidual contracts.
          </Text>
        </Box>

        <Box className="space-y-4">
          <Heading as="h2" size="5" className="text-blue-950">
            4. Orders and Payments
          </Heading>
          <ul className="list-disc pl-6 space-y-2">
            <li className="text-slate-600">
              <Text size="3">
                All orders for services must be placed through our website.
              </Text>
            </li>
            <li className="text-slate-600">
              <Text size="3">
                Payment must be made at the time of placing the order unless
                otherwise agreed upon.
              </Text>
            </li>
            <li className="text-slate-600">
              <Text size="3">
                We accept various forms of payment, including credit/debit cards
                and online payment systems.
              </Text>
            </li>
          </ul>
        </Box>

        <Box className="space-y-4">
          <Heading as="h2" size="5" className="text-blue-950">
            5. Cancellations and Refunds
          </Heading>
          <ul className="list-disc pl-6 space-y-2">
            <li className="text-slate-600">
              <Text size="3">
                Orders can be canceled up to 24 hours before the scheduled
                delivery time.
              </Text>
            </li>
            <li className="text-slate-600">
              <Text size="3">
                Refunds will be processed within 14 days of cancellation, and
                the amount refunded will depend on the services provided up to
                the point of cancellation.
              </Text>
            </li>
          </ul>
        </Box>

        <Box className="space-y-4">
          <Heading as="h2" size="5" className="text-blue-950">
            6. User Responsibilities
          </Heading>
          <ul className="list-disc pl-6 space-y-2">
            <li className="text-slate-600">
              <Text size="3">
                You agree to use our services in a lawful manner and in
                accordance with these terms and conditions.
              </Text>
            </li>
            <li className="text-slate-600">
              <Text size="3">
                You must not misuse our website by introducing viruses, trojans,
                worms, or other material which is malicious or technologically
                harmful.
              </Text>
            </li>
          </ul>
        </Box>

        <Box className="space-y-4">
          <Heading as="h2" size="5" className="text-blue-950">
            7. Intellectual Property Rights
          </Heading>
          <ul className="list-disc pl-6 space-y-2">
            <li className="text-slate-600">
              <Text size="3">
                Other than the content you own, under these Terms,{' '}
                {website?.organization.name} and/or its licensors own all the
                intellectual property rights and materials contained in this
                Website.
              </Text>
            </li>
            <li className="text-slate-600">
              <Text size="3">
                You are granted a limited license only for purposes of viewing
                the material contained on this Website.
              </Text>
            </li>
          </ul>
        </Box>

        <Box className="space-y-4">
          <Heading as="h2" size="5" className="text-blue-950">
            8. Limitation of Liability
          </Heading>
          <Text as="p" size="3" className="text-slate-600">
            In no event shall {website?.organization.name}, nor any of its
            officers, directors, and employees, be held liable for anything
            arising out of or in any way connected with your use of this
            Website. {website?.organization.name}, including its officers,
            directors, and employees shall not be held liable for any indirect,
            consequential, or special liability arising out of or in any way
            related to your use of this Website.
          </Text>
        </Box>

        <Box className="space-y-4">
          <Heading as="h2" size="5" className="text-blue-950">
            9. Changes to Terms
          </Heading>
          <Text as="p" size="3" className="text-slate-600">
            We reserve the right to amend these terms and conditions at any
            time. Any changes will be posted on this page and will become
            effective upon posting.
          </Text>
        </Box>

        <Box className="space-y-4">
          <Heading as="h2" size="5" className="text-blue-950">
            10. Governing Law
          </Heading>
          <Text as="p" size="3" className="text-slate-600">
            These terms and conditions are governed by and construed in
            accordance with the laws of United States, and you irrevocably
            submit to the exclusive jurisdiction of the courts in that State or
            location.
          </Text>
        </Box>
      </Box>
    </Container>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/terms-and-conditions',
  component: TermsPage,
});

export default Route;
